import { WebsiteTheme } from "@/components/apps/website/LandingPagePreview"

export const Result = {
    ok: <T>(data: T) => ({
        ok: true,
        data,
        err: null
    } as const),
    err: <T>(err: T) => ({
        ok: false,
        data: null,
        err
    } as const)
}

export function sleep(milliseconds: number): Promise<undefined> {
    return new Promise((resolve) => setTimeout(resolve, milliseconds))
}

export function friendlyPhone(phoneNumberString: string): string {
    const cleaned = ("" + phoneNumberString).replace(/\D/g, "")
    // what the hell does this even do?
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (!match) {
        return "000-000-0000"
    }
    const intlCode = match[1] ? "+1 " : ""
    const phoneParts = [
        intlCode, 
        "(", match[2], ") ", 
        match[3], "-", match[4]
    ]
    return phoneParts.join("")
}

export function roundDecimal(
    decimal: number, places: number
): number {
    const factor = 10 ** Math.max(places, 1)
    return Math.round(decimal * factor) / factor
}

export async function themesSha256(
    themes: WebsiteTheme[]
): Promise<string> {
    const hashStr = themes.reduce((t, next) => `\
${t}
${next._id}|\
${next.name}|\
${next.legacyId}|\
${next.primaryColor}|\
${next.secondaryColor}|\
${next.secondaryContrast}|\
${next.accentColorDark}|\
${next.accentColorLight}|\
    `, "")
    const binStr = new TextEncoder().encode(hashStr)
    const sha256 = await crypto.subtle.digest("sha-256", binStr)
    const digest = new Uint8Array(sha256)
    let digestStr = ""
    for (const byte of digest) {
      const hex = byte.toString(16)
      digestStr += hex
    }
    return digestStr
}   